import React, { useContext, useEffect, useState } from 'react'
import { VendorContext } from '../../App'
import './sidebar.css'
import SideMenu from './Components/SideMenu'
import CategoryDrawer from './Components/CategoryDrawer'

const NewSideBar = ({ setBurger }) => {
    const details = useContext(VendorContext)
    const [openCategories, setOpenCategories] = useState(false)
    const handleCategory = () => {
        setOpenCategories(!openCategories)
    }
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [])

    return (
        <div className='side-bar-backdrop' id="navbar-id">
            {
                !openCategories && <SideMenu
                    details={details}
                    setBurger={setBurger}
                    handleCategory={handleCategory}
                />
            }
            {
                openCategories && <CategoryDrawer
                    details={details}
                    setBurger={setBurger}
                    handleCategory={handleCategory}
                />
            }
        </div>
    )
}

export default NewSideBar